document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.video-testmonial').forEach(function (section) {
    const sectionId = section.dataset.sectionId;

    const swiper = new Swiper('.video-testmonial__slider--' + sectionId, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: '.video-testmonial__slider--' + sectionId + ' .video-testmonial__arrow--next',
        prevEl: '.video-testmonial__slider--' + sectionId + ' .video-testmonial__arrow--prev',
      },
      breakpoints: {
        769: { slidesPerView: 3 },
        991: { slidesPerView: 4 },
      },
    });

    const slides = section.querySelectorAll('.video-testmonial__slide');

    function stopAllVideos() {
      slides.forEach(function (slide) {
        const video = slide.querySelector('video');
        if (!video) return;

        video.pause();
        if (video.dataset.originalPoster) {
          video.setAttribute('poster', video.dataset.originalPoster);
        }

        slide.classList.remove('is-playing');

        const playIcon = slide.querySelector('.video-testmonial__icon--play');
        const pauseIcon = slide.querySelector('.video-testmonial__icon--pause');

        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      });
    }

    function setupSlide(slide) {
      const video = slide.querySelector('video');
      const muteBtn = slide.querySelector('.video-testmonial__slide--controls');
      const playBtn = slide.querySelector('.video-testmonial__slide--playpause');

      if (!video) return;

      const originalPoster = video.getAttribute('poster');
      if (originalPoster) {
        video.dataset.originalPoster = originalPoster;
      }

      video.muted = true;
      video.pause();
      slide.classList.remove('is-playing');

      function updatePlayIcon() {
        const playIcon = playBtn?.querySelector('.video-testmonial__icon--play');
        const pauseIcon = playBtn?.querySelector('.video-testmonial__icon--pause');
        if (!playIcon || !pauseIcon) return;
        if (video.paused) {
          playIcon.style.display = '';
          pauseIcon.style.display = 'none';
          slide.classList.remove('is-playing');
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = '';
          slide.classList.add('is-playing');
        }
      }

      function updateMuteIcon() {
        const mutedIcon = muteBtn?.querySelector('.video-testmonial__icon--muted');
        const unmutedIcon = muteBtn?.querySelector('.video-testmonial__icon--unmuted');
        if (!mutedIcon || !unmutedIcon) return;
        mutedIcon.style.display = video.muted ? '' : 'none';
        unmutedIcon.style.display = video.muted ? 'none' : '';
      }

      updatePlayIcon();
      updateMuteIcon();

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (video.paused) {
            stopAllVideos();

            video.removeAttribute('poster');
            video.currentTime = 0;

            video.play().then(function () {
              updatePlayIcon();
              video.onended = function () {
                const idx = Array.from(slides).indexOf(slide);
                playSlideAt(idx + 1);
              };
            });
          } else {
            video.pause();
            updatePlayIcon();
          }
        });
      }

      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          updateMuteIcon();
        });
      }
    }

    function playSlideAt(index) {
      if (index >= slides.length) index = 0;

      stopAllVideos();
      swiper.slideTo(index);

      const slide = slides[index];
      const video = slide.querySelector('video');
      if (!video) return;

      video.removeAttribute('poster');
      video.currentTime = 0;
      video.muted = true;

      video.play().then(function () {
        slide.classList.add('is-playing');

        const playIcon = slide.querySelector('.video-testmonial__icon--play');
        const pauseIcon = slide.querySelector('.video-testmonial__icon--pause');

        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = '';

        video.onended = function () {
          playSlideAt(index + 1);
        };
      }).catch(function (err) {
        console.warn('Autoplay blocked:', err);
      });
    }

    slides.forEach(setupSlide);
    playSlideAt(0);
  });
});